<template>
  <header class="page-header">
    <!-- RD Navbar -->
    <div class="rd-navbar-wrap">
      <nav class="rd-navbar" ref="nav_container" data-rd-navbar-lg="rd-navbar-fullwidth">
        <div class="rd-navbar-inner">
          <!-- RD Navbar Panel -->
          <div class="rd-navbar-panel">
            <!-- RD Navbar Toggle -->
            <button class="rd-navbar-toggle" ref="ham_button" data-rd-navbar-toggle=".rd-navbar"><span></span></button>
            <!-- END RD Navbar Toggle -->
            <!-- RD Navbar Brand -->
            <a class="rd-navbar-brand">
              <router-link to="/">
                <!--<div class="brand-logo"></div>-->
                <div class="brand-name">
                  <span class="text-uppercase">ELIZABETH</span>
                </div>
                <div class="brand-slogan">European Skin Care <p class="brand-slogan">Est. 1985</p></div>
              </router-link>
            </a>
            <!-- END RD Navbar Brand -->
            <!-- RD Navbar Toggle Collapse-->
            <button class="rd-navbar-collapse-toggle" data-rd-navbar-toggle=".rd-navbar-collapse">
            <span></span>
            </button>
            <!--END RD Navbar Toggle Collapse-->
            <address class="contact-info rd-navbar-collapse">
              <dl class="terms-list">
                <dt>Telephone</dt>
                <dd><a href="callto:#">718 520 0911</a></dd>
              </dl>
              <ul class="inline-list">
                <li><a href="https://www.facebook.com/elizabethsskincare" class="icon icon-xs fa-facebook"></a></li>
                <li><a href="#" class="icon icon-xs fa-twitter"></a></li>
                <li><a href="#" class="icon icon-xs fa-pinterest"></a></li>
                <li><a href="#" class="icon icon-xs fa-google-plus"></a></li>
                <li><a href="#" class="icon icon-xs fa-instagram"></a></li>
              </ul>
            </address>
          </div>
          <!-- END RD Navbar Panel -->
          <div class="rd-navbar-nav-wrap">
            <!-- RD Navbar Nav -->
            <ul class="rd-navbar-nav">
              <li :class="[currentPath=='home' ? 'active' : '']" class="menu-home">
                <router-link tag="a" to="/">Home</router-link>
              </li>
              <li :class="[currentPath=='about-us' ? 'active' : '']" class="menu-about-us" >
                <router-link tag="a" to="/about-us">About us</router-link>
              </li>
              <li :class="[currentPath=='services' ? 'active' : '']" class="menu-services">
                <router-link tag="a" to="/services">Services</router-link>
              </li>
              <li :class="[currentPath=='please-note' ? 'active' : '']" class="menu-please-note">
                <router-link tag="a" to="/please-note">Please Note</router-link>
              </li>
              <li :class="[currentPath=='contact-us' ? 'active' : '']" class="menu-contact-us">
                <router-link tag="a" to="/contact-us">Contact us</router-link>
              </li>
              <li :class="[currentPath=='products' ? 'active' : '']" class="menu-products maroon-color">
                <router-link tag="a" to="/products">Shop Here</router-link>
              </li>
            </ul>
            <!-- END RD Navbar Nav -->
          </div>
        </div>
      </nav>
    </div>
    <!-- END RD Navbar -->
  </header>

</template>

<script>
  import $ from 'jquery';
  window.$ = window.jQuery  = $;

  import rdScript from '@/assets/js/script.js';

  export default {
    name: 'Header',
    data: function() {
      return {
        currentPath: this.$route && this.$route.name ? this.$route.name : '', 
      }
    },
    mounted() {
      rdScript();
    },
    watch: {
      $route (to, from){
        if (to.name === from.name) return;

        this.$refs.nav_container.className = this.$refs.nav_container.className.replace("active", "");
        this.$refs.ham_button.className = this.$refs.ham_button.className.replace("active", "");

        this.currentPath = to.name;
        rdScript();

        let navCloneEl = $('.rd-navbar--is-clone');
        if(navCloneEl.length) {
          navCloneEl.find('.rd-navbar-nav-wrap li').removeClass('active').parent().find('.menu-' + this.currentPath).addClass('active');
        }
      }
    }
  }
</script>

<style scoped>
  
</style>